import app from 'flarum/common/app';
import MeritTransaction from './models/MeritTransaction';
import MeritBadge from './models/MeritBadge';

app.initializers.add('predictiontalk-merit-system-common', () => {
    app.store.models['merit-transactions'] = MeritTransaction;
    app.store.models['merit-badges'] = MeritBadge;
});
